export default {
  shoppingCartView: {
    title: 'Shopping Cart',
    agencyProductsSubtitle: 'Agency products',
    boutiqueProductsSubtitle: 'Shop products',
    reservedProductsSubtitle: 'Reserved',
    unavailableLabel: 'Unavailable',
    unavailableHint: 'Remove this item to continue',
    unavailableCheckoutBlocked: 'One or more items in your cart are no longer available. Please remove them to continue your order.',
    removeUnavailable: 'Remove from cart',
    foreignInventoryTitle: 'Error!',
    foreignInventory: 'This product comes from another region\'s inventory and cannot be added to this cart.',
  },
  shoppingCartEmptyView: {
    infoPar1Span1: 'Your shopping cart is empty. If you are thirsty, fill it up by exploring the product selection offered through the ',
    infoPar1Span2: 'Montreal Shop,',
    infoPar1Span3: ' or ',
    infoPar1Span4: 'agency',
    infoPar1Span5: '.',
    infoPar1Span7: ' Shop Quebec',
    infoPar2Span1: 'Psst, you can also find ',
    infoPar2Span2: '',
    infoPar2Span3: ' takeout food items and other ',
    infoPar2Span4: 'related products',
    infoPar2Span5: '.',
    infoPar1Span8: '  Toronto Shop',
  },
  shoppingCartSummaryComponent: {
    summary: 'Summary',
    agency: 'Agency',
    agencyFees: 'Agency fees',
    saqFees: 'SAQ fees',
    subTotal: 'Pay at the Saq',
    payNow: 'Pay now',
    boutique: 'Shop',
    tps: 'GST',
    tvq: 'QST',
    hst: 'HST',
    total: 'Total',
    toPaySaq: 'To be paid at the SAQ (+ tx.)',
    toPayNow: 'Subtotal',
    ctaOrder: 'Order',
    validation: 'The quantity added for this product isn\'t available, please, remove the product or reduce the quantity',
    soldOut: 'this product has sold out since it was added to your cart and must be removed to continue your order.'
  },
  shoppingCartAuthModel: {
    placeOrder: 'Placing an order',
    guestOrder: 'Ordering as a guest',
    register: 'Already registered?',
    registerNow: 'Register now',
    signIn: 'Sign in',
    continue: 'Continue',
    createAccount: 'Create account'
  }
};
